<template>
  <b-card>
      <div slot="header">
          <i class="fa fa-list-ul" aria-hidden="true"></i>
              {{text.oneAppMessagingSetting}}
          <div class="card-header-actions">
              <a href="https://bootstrap-vue.js.org/docs/components/progress" class="card-header-action" rel="noreferrer noopener" target="_blank">
              <small class="text-muted">{{text.docs}}</small>
              </a>
          </div>
      </div>
      <alert-success :redirectName="'one_app_messaging-home'" :show="successMessage != ''"> {{ successMessage }} </alert-success>
      <b-alert class="text-center" :show="errorMessage != ''" variant="danger"> {{ errorMessage }} </b-alert>

          <!-- Mqdc One Select -->
          <b-form-group>
            <label>{{text.mqdcOneApp}}</label>
            <v-select class="select-condition" v-model="appId"  :options="appOptions"></v-select>
          </b-form-group>

    <div slot="footer">
        <b-button @click="$router.go(-1)" class="mr-2" size="sm" variant="secondary">
            <i class="fa fa-angle-left" aria-hidden="true"></i>
            {{text.back}}
          </b-button>
          <b-button :disabled="!isActive" @click="save" class="mr-2" type="submit" size="sm" variant="primary">
            <i class="fa fa-dot-circle-o"></i>
            {{text.save}}
          </b-button>
      </div>
  </b-card>
</template>

<script>
import vSelect from 'vue-select';
import { OptionList } from '../../../models/option-list';
import AlertSuccess from '../../../components/alert/AlertSuccess';
import { textOneAppMessaging } from '@/assets/utils/language';

export default {
  data () {
    return {
      errorMessage: '',
      successMessage: '',
      appId: null,
      isActive: true,
      optionList: new OptionList(this.axios),
      appOptions: [],
      text: {}
    };
  },
  methods: {
    getData () {
      this.axios.get(process.env.VUE_APP_URL_MESSAGING_API + '/setting/get-app-for-mqdc-one-notification')
        .then(response => {
          const data = response.data.data;
          const appId = data.appId;
          const app = this.appOptions.find(option => option.code === appId);
          if (app) {
            this.appId = app;
          }
        })
        .catch(error => {
          this.handleError(error);
        });
    },
    save () {
      this.isActive = false;
      this.errorMessage = '';
      const json = {
        'appId': this.appId.code
      };
      this.axios.post(process.env.VUE_APP_URL_MESSAGING_API + '/setting/set-app-for-mqdc-one-notification', json)
        .then(response => {
          this.successMessage = 'update mqdc one app successfully.';
        })
        .catch(error => {
          this.handleError(error);
        })
        .finally(() => {
          this.isActive = true;
        });
    },
    handleError (error) {
      this.errorMessage = error.response && error.response.data && error.response.data.data ? error.response.data.data : error.message;
    }
  },
  components: {
    'v-select': vSelect,
    AlertSuccess
  },
  watch: {
    $language: function () {
      this.text = textOneAppMessaging(this.$language);
    }
  },
  mounted () {
    this.text = textOneAppMessaging(this.$language);
    this.optionList.loadAppOptions()
      .then(response => {
        this.appOptions = response;
        this.getData();
      })
      .catch(error => console.log(error));
  }
};
</script>

<style scoped>
  .hint{
    font-size: 9px;
    color: #f86c6b;
  }
</style>
<style>
    .pagination {
        margin-left: auto;
        margin-right: auto;
    }
    .users-filter .vs__search::placeholder,
    .users-filter .vs__dropdown-toggle,
    .users-filter .vs__dropdown-menu {
        color: #394066;
        font-variant: small-caps;
        border: 1px solid #e4e7ea;
    }
    .vs__dropdown-menu{
      max-height: 150px !important;
    }
    .filter-status {
        margin-top: 1px;
    }
    .w-30{
    width: 30% !important;
    }
    .w-70{
      width: 70% !important;
    }
</style>
